var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.crumbs),function(crumb,index){return _c('span',{key:index,on:{"click":function($event){return _vm.crumbClicked(crumb)}}},[_c('span',{staticClass:"pointer underlined"},[_vm._v(_vm._s(crumb.title))]),_vm._v(" "),_c('span',[_vm._v(" / ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee6fc8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/General/Breadcrumbs.vue
// module id = null
// module chunks = 